import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { BsPaperclip } from "react-icons/bs";
import { notifyError, notifySuccess } from "../../utils/toast";
import socket from "services/SocketService";

const Uploader = ({
  setImageUrl,
  imageUrl,
  is_multiple,
  no_of_image,
  folder,
  name_merge,
  onImageUpload,
  chatId,
  senderId,
  receiverId,
  senderName,
  receiverName,
  setMessages,
}) => {
  const [files, setFiles] = useState([]);
  const [, setLoading] = useState(false);
  const [, setError] = useState("");

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: "image/jpeg, image/jpg, application/pdf",
    multiple: is_multiple,
    // maxSize: 155000,
    maxFiles: no_of_image || 2,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  useEffect(() => {
    if (fileRejections && fileRejections.length > 0) {
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach((error) => {
          if (error.code === "file-too-large") {
            notifyError(`File exceeds the maximum size of 150KB.`);
          } else if (error.code === "too-many-files") {
            notifyError(`Maximum ${no_of_image || 2} images can be uploaded.`);
          } else {
            notifyError(
              `Error uploading file "${file.path}": ${error.message}`
            );
          }
        });
      });
    }
    if (files && files.length > 0) {
      const imageUrlCount = Array.isArray(imageUrl)
        ? imageUrl.length
        : imageUrl
        ? 1
        : 0;
      if (is_multiple === true && imageUrlCount + files?.length > no_of_image) {
        return notifyError(
          `Maximum ${no_of_image ? no_of_image : 2} Image Can be Upload!`
        );
      }

      setLoading(true);
      setError("Uploading....");
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append("file", file);
      });
      const uploadedFileType = files.every((file) => file.type.startsWith("image/"))
  ? "image"
  : files.every((file) => file.type === "application/pdf")
  ? "pdf"
  : "other";

formData.append("type", uploadedFileType); 
      formData.append("folderName", folder);
      formData.append("name_merge", name_merge);

      axios({
        url: `${process.env.REACT_APP_API_SOCKET_URL}/upload`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((res) => {
          notifySuccess(`${uploadedFileType} uploaded successfully!`);
          setLoading(false);
          if (res) {

            if (files.length > 1) {
              setImageUrl(res.data.imageUrl);
            } else {
              setImageUrl(res.data.imageUrl);
            }
            if (onImageUpload) {
              onImageUpload(res.data.imageUrl); // Callback to send the image path back
            }
            setMessages((prev) => [
              ...prev,
              { sender: "Me", text: res.data.imageUrl, type: uploadedFileType, time: new Date()  },
            ]);
            
            socket.emit("send_image", {
              chatId,
              senderId,
              receiverId,
              imageUrl: res.data.imageUrl,
              senderName,
              receiverName,
              type: uploadedFileType
            });
          }
          setFiles([]);
          setImageUrl();
        })
        .catch((err) => {
          console.error("err", err);
          notifyError(err.Message);
          setLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [files]);

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  return (
    <>
      {/* Conditional Rendering for Drag-and-Drop Area */}
      {!(
        (is_multiple &&
          (files.length > 0 ||
            (Array.isArray(imageUrl) && imageUrl.length > 0))) ||
        (!is_multiple && (imageUrl || files.length > 0))
      ) && (
        <div {...getRootProps()}>
          <BsPaperclip size={22} />
          <input {...getInputProps()} />
        </div>
      )}
    </>
  );
};

export default Uploader;
